
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5c3.854 0 7 3.146 7 7 0 3.514-2.617 6.417-6 6.906V28h-2v-9.094c-3.383-.489-6-3.392-6-6.906 0-3.854 3.146-7 7-7zm0 2c-2.773 0-5 2.227-5 5s2.227 5 5 5 5-2.227 5-5-2.227-5-5-5zm0 1v2c-1.117 0-2 .883-2 2h-2c0-2.197 1.803-4 4-4z"}})])
          )
        }
      }
    